module.exports = [
  {
    name: "VENEZUELA DIGITAL - Estrategia País. Sector Petrolero & Gasífero como motor de la transformación industrial hacia un Hub Tecnológico & Energético en las Américas",
    img: "./images/eventplaceholdernull.png",
    day: "16",
    month: "JAN, 26",
    year: "2026",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      `Francisco Sánchez`,
    ],
    links: ["https://meet.goto.com/646838253"],
  },
  {
    name: "Anaco Rejuvenece. Más gas para alimentar hogares y dinamizar el sector industrial",
    img: "./images/eventplaceholdernull3.png",
    day: "12",
    month: "DEC, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      `Tomás Mata`,
    ],
    links: ["https://www.youtube.com/watch?v=QaBeRr6Sx9w"],
  },
  {
    name: "Tecnología Química RDV® Reactor Dinámico Vasoactivo",
    img: "./images/eventplaceholdernull2.png",
    day: "05",
    month: "DEC, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      `William Jiménez C`,
    ],
    links: ["https://www.youtube.com/watch?v=Pv1jhTfeWmM"],
  },
  {
    name: "El Poder, ¿Volar o arrastrarse?",
    img: "./images/eventplaceholdernull.png",
    day: "21",
    month: "NOV, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      `Aquímedes Román`,
    ],
    links: ["https://www.youtube.com/watch?v=SyqmiwyyYJw"],
  },
  {
    name: "Bioética y Derechos Humanos",
    img: "./images/eventplaceholdernull3.png",
    day: "14",
    month: "NOV, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      `Dr Gabriel D'Ampare`,
    ],
    links: ["https://www.youtube.com/watch?v=CvlDdc-nvYU"],
  },
  {
    name: "Declina la producción de shale oil en USA Una oportunidad para Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "07",
    month: "NOV, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Evanán Romero',
    ],
    links: ["https://www.youtube.com/watch?v=fAI8JrO5KC0"],
  },
  {
    name: "Una estrategia para Venezuela del Asistencialismo al Mercado",
    img: "./images/eventplaceholdernull.png",
    day: "31",
    month: "OCT, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Benjamin Trapier',
    ],
    links: ["https://www.youtube.com/watch?v=SLbKhgqVGKs"],
  },
  {
    name: "Significado de privatizar en Venezuela",
    img: "./images/eventplaceholdernull3.png",
    day: "24",
    month: "OCT, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'José Manuel Andrade-Cuadra',
    ],
    links: ["https://www.youtube.com/watch?v=CMkfoEHtrA0"],
  },
  {
    name: "IA Riesgos y Oportunidades",
    img: "./images/eventplaceholdernull2.png",
    day: "10",
    month: "OCT, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Vladimiro Mujica',
    ],
    links: ["https://www.youtube.com/watch?v=KKk-3kOr8hA"],
  },
  {
    name: "Las Perlas del Caribe Del Pozo a la Arepa",
    img: "./images/eventplaceholdernull.png",
    day: "03",
    month: "OCT, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Tomás Mata',
    ],
    links: ["https://www.youtube.com/watch?v=MKZRdLDuE1g"],
  },
  {
    name: "Lo que el CAIDI puede hacer por los migrantes venezolanos",
    img: "./images/eventplaceholdernull3.png",
    day: "26",
    month: "SEP, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Edda Caputto',
    ],
    links: ["https://www.youtube.com/watch?v=QzRAqDF4eAk"],
  },
  {
    name: "Uso de nanofluidos en la producción de petróleo",
    img: "./images/eventplaceholdernull2.png",
    day: "19",
    month: "SEP, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Claudio Martínez',
    ],
    links: ["https://www.youtube.com/watch?v=ROL1pVhp2YU"],
  },
  {
    name: "CITGO Piedra angular para los primeros años de la Transición",
    img: "./images/eventplaceholdernull.png",
    day: "12",
    month: "SEP, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Horacio Medina',
    ],
    links: ["https://www.youtube.com/watch?v=aScV7ByG374"],
  },
  {
    name: "Inteligencia Artificial a tu alcance",
    img: "./images/eventplaceholdernull3.png",
    day: "05",
    month: "SEP, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Adem M. Wulff',
    ],
    links: ["https://www.youtube.com/watch?v=-KoumDmf0sc"],
  },
  {
    name: "Desarrollo de la IPN mediante estrategias de tercerización",
    img: "./images/eventplaceholdernull2.png",
    day: "29",
    month: "AUG, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Armando R. Carrillo',
    ],
    links: ["https://www.youtube.com/watch?v=GAjclXdknwk"],
  },
  {
    name: "INTELIGENCIA ARTIFICIAL, De la curiosidad al uso inteligente",
    img: "./images/eventplaceholdernull.png",
    day: "22",
    month: "AUG, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Oviedo Perera Moser',
    ],
    links: ["https://www.youtube.com/watch?v=3EkwD8Xnojc"],
  },
  {
    name: "La solvencia financiera del Estado Venezolano",
    img: "./images/eventplaceholdernull3.png",
    day: "15",
    month: "AUG, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Gustavo García',
    ],
    links: ["https://www.youtube.com/watch?v=_vkRU0J6kVI"],
  },
  {
    name: "Las dos tecnologías probadas que cambiarían a futuro el perfil productivo de la Faja del Orinoco",
    img: "./images/eventplaceholdernull2.png",
    day: "08",
    month: "AUG, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Evanán Romero',
    ],
    links: ["https://www.youtube.com/watch?v=FqALHMUoOhA"],
  },
  {
    name: "Potencialidad de Venezuela",
    img: "./images/eventplaceholdernull1.png",
    day: "18",
    month: "JUL, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Sary Levy Carciente',
    ],
    links: ["https://www.youtube.com/watch?v=a6wmT2bvLAQ"],
  },
  {
    name: "La empresa y su transformación digital asistida por IA",
    img: "./images/eventplaceholdernull2.png",
    day: "11",
    month: "JUL, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Jonás A. Montilva',
    ],
    links: ["https://www.youtube.com/watch?v=uq-m0bxDqIo"],
  },
  {
    name: "Hidrocarburos Venezolanos, esperanza nacional y necesidad mundial",
    img: "./images/eventplaceholdernull.png",
    day: "27",
    month: "JUN, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Juan Szabo',
    ],
    links: ["https://www.youtube.com/watch?v=Zb3qQyYPeTk"],
  },
  {
    name: "Inteligencia artificial en el sector energético",
    img: "./images/eventplaceholdernull3.png",
    day: "20",
    month: "JUN, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'GEORGE TABORDA',
    ],
    links: ["https://www.youtube.com/watch?v=LCePQYCGSfk"],
  },
  {
    name: "Cómo usar el Poder Transformador del Petróleo para Erradicar la Pobreza",
    img: "./images/eventplaceholdernull2.png",
    day: "13",
    month: "JUN, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'TOMÁS MATA',
    ],
    links: ["https://www.youtube.com/watch?v=7TB7XAHIRd8"],
  },
  {
    name: "VAPAResPro",
    img: "./images/eventplaceholdernull.png",
    day: "07",
    month: "JUN, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Alfonso Quaglia',
    ],
    links: ["https://www.youtube.com/watch?v=e0agLMWeOWQ"],
  },
  {
    name: "Otros dos Papas Francisco y León XIV",
    img: "./images/eventplaceholdernull3.png",
    day: "31",
    month: "MAY, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Asdrubal Aguiar',
    ],
    links: ["https://www.youtube.com/watch?v=x4_TOF9IxSQ"],
  },
  {
    name: "GERENCIA INTEGRADA DE CAMPOS DE HIDROCARBUROS",
    img: "./images/eventplaceholdernull2.png",
    day: "25",
    month: "MAY, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Julián Salazar Velásquez',
    ],
    links: ["https://www.youtube.com/watch?v=XqiFxhQfaXE"],
  },
  {
    name: "Estatismo en la la Industria Petrolera",
    img: "./images/eventplaceholdernull.png",
    day: "17",
    month: "MAY, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Evanán Romero',
    ],
    links: ["https://www.youtube.com/watch?v=L8FVvmDAuRE"],
  },
  {
    name: "Cambio organizacional y cultura El caso de Venezuela",
    img: "./images/eventplaceholdernull3.png",
    day: "10",
    month: "MAY, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Alberto Rial'
    ],
    links: ["https://www.youtube.com/watch?v=fyq4cTRwVJw"],
  },
  {
    name: "Cambio organizacional y cultura El caso de Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "10",
    month: "MAY, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Alberto Rial'
    ],
    links: ["https://www.youtube.com/watch?v=fyq4cTRwVJw"],
  },
  {
    name: "Confiabilidad Integral de Procesos Productivos",
    img: "./images/eventplaceholdernull.png",
    day: "03",
    month: "MAY, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Medardo Yañez'
    ],
    links: ["https://www.youtube.com/watch?v=aNjGvOTm-Ts"],
  },
  {
    name: "La electricidad en Venezuela como palanca de cualquier expectativa de un buen futuro",
    img: "./images/eventplaceholdernull3.png",
    day: "27",
    month: "APRIL, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Benjamín Tripier'
    ],
    links: ["https://www.youtube.com/watch?v=coTvA0kkhMQ"],
  },
  {
    name: " Propuesta de Un nuevo desarrollo CTI para Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "18",
    month: "APRIL, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'José Manuel Martínez'
    ],
    links: ["https://youtu.be/Kph_5mkbHOY"],
  },
  {
    name: "El sistema de patentes en USA",
    img: "./images/eventplaceholdernull.png",
    day: "11",
    month: "APRIL, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Carlos Ruiz'
    ],
    links: ["https://youtu.be/Gkwunmltpfc"],
  },
  {
    name: "CERAWEEK 2025 by S&P Global",
    img: "./images/eventplaceholdernull3.png",
    day: "04",
    month: "APRIL, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: [
      'Jorge Zajía',
      'Edgar Peláez',
      'Carlos Sánchez',
      'Tomás Mata'
    ],
    links: ["https://www.youtube.com/watch?v=OZpk0mN19_c"],
  },
  {
    name: "Codicia Auge y declinación de la Cúpula Bancaria en Venezuela 1974 1994",
    img: "./images/eventplaceholdernull2.png",
    day: "21",
    month: "MARCH, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gerardo Lucas"],
    links: ["https://www.youtube.com/watch?v=u264BVIeKbA"],
  },
  {
    name: "SISTEMA INTEGRAL DE OPTIMIZACION DE PRODUCCION POR EFECTOS PULSANTES (SIOP)",
    img: "./images/eventplaceholdernull.png",
    day: "14",
    month: "MARCH, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Henry Pino"],
    links: ["https://www.youtube.com/watch?v=l-dBkoV78dY"],
  },
  {
    name: "Lentes para la miopía petrolera",
    img: "./images/eventplaceholdernull3.png",
    day: "07",
    month: "MARCH, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Rafael Gallegos"],
    links: ["https://youtu.be/zOBAdsbq5I4"],
  },
  {
    name: "Caracterización Petrofísica Avanzada* expuesto por *Douglas Betancourt",
    img: "./images/eventplaceholdernull2.png",
    day: "28",
    month: "FEB, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Douglas Betancourt"],
    links: ["https://youtu.be/vYd4io8w6_Q"],
  },
  {
    name: "IA: EL ASTEROIDE INTANGIBLE",
    img: "./images/eventplaceholdernull.png",
    day: "21",
    month: "FEB, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Luis Ismodes"],
    links: ["https://youtu.be/O3Fu6IDQLoA"],
  },
  {
    name: "Renovables y Fósiles: El Futuro de la Energía en Equilibrio",
    img: "./images/eventplaceholdernull3.png",
    day: "14",
    month: "FEB, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Claudio Martínez"],
    links: ["https://youtu.be/nVg0tHf_ZHI"],
  },
  {
    name: "Drill baby, drill",
    img: "./images/eventplaceholdernull2.png",
    day: "07",
    month: "FEB, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Francisco Gamarra", "Tyrone Perdomo", "Evanán Romero"],
    links: ["https://www.youtube.com/watch?v=Q0P7GGoVFTs"],
  },
  {
    name: "Se administran 0rganizaciones, se lideran personas",
    img: "./images/eventplaceholdernull.png",
    day: "31",
    month: "JAN, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Eduardo Martí F"],
    links: ["https://youtu.be/q-KKKFFHFRg"],
  },
  {
    name: "La Influencia geopolítica del Foro de Sao Paul",
    img: "./images/eventplaceholdernull3.png",
    day: "24",
    month: "JAN, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Alejandro Peña Esclusa"],
    links: ["https://youtu.be/r_lOLVc89h4"],
  },
  {
    name:
      "Revolución de la Gerencia Integrada de Yacimiento con el uso de Inteligencia Artificial",
    img: "./images/eventplaceholdernull3.png",
    day: "17",
    month: "JAN, 25",
    year: "2025",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Claudio Martínez"],
    links: ["https://www.youtube.com/watch?v=TijV37vdDBc"],
  },
  {
    name: "El país que queremos",
    img: "./images/eventplaceholdernull2.png",
    day: "22",
    month: "DEC, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Rafael de la Cruz"],
    links: ["https://www.youtube.com/watch?v=MUD30syDIbU"],
  },
  {
    name: "Venezuela - Camino al Futuro",
    img: "./images/eventplaceholdernull1.png",
    day: "06",
    month: "DEC, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Dr. R. Evan Ellis"],
    links: ["https://youtu.be/_NuVMFkbZZ4"],
  },
  {
    name: "Ganó Trump!!! Cómo puede impactar eso en Venezuela?",
    img: "./images/eventplaceholdernull3.png",
    day: "15",
    month: "NOV, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Casto Ocando"],
    links: ["https://youtu.be/HHAgaP8Sp74"],
  },
  {
    name: "El Poder de la Gente en el Renacimiento de Venezuela.",
    img: "./images/eventplaceholdernull2.png",
    day: "08",
    month: "NOV, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Tomás Mata"],
    links: ["https://youtu.be/NVaKnaKsQH0"],
  },
  {
    name: "Computación en la nube. Oportunidades de negocios y desafíos.",
    img: "./images/eventplaceholdernull.png",
    day: "01",
    month: "NOV, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["William R. Colina"],
    links: ["https://youtu.be/CcdqW27hTaw"],
  },
  {
    name: "La inversión en Infraestructura un desafío costoso pero impostergable",
    img: "./images/eventplaceholdernull3.png",
    day: "25",
    month: "OCT, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["José María de Viana"],
    links: ["https://youtu.be/UOGDYR9Kb-M"],
  },
  {
    name: "Amaneció Temprano- Historia de dos Venezuelas",
    img: "./images/eventplaceholdernull2.png",
    day: "18",
    month: "OCT, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Alberto Rial"],
    links: ["https://youtu.be/e6N7vTt8NjI"],
  },
  {
    name: "Venezuela a futuro",
    img: "./images/eventplaceholdernull.png",
    day: "11",
    month: "OCT, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Dra. Sary Levy Carciente"],
    links: ["https://youtu.be/aDohCFTJS2w"],
  },
  {
    name: "VENEZUELA PETROLERA: SEIS CUENTOS Y TRES REMORDIMIENTOS",
    img: "./images/eventplaceholdernull3.png",
    day: "27",
    month: "SEP, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Rafael Gallegos"],
    links: ["https://youtu.be/_3dZBXioG6E"],
  },
  {
    name:
      "¿Son las reservas de petróleo y gas de Venezuela cruciales para la seguridad a largo plazo del hemisferio occidental?",
    img: "./images/eventplaceholdernull2.png",
    day: "20",
    month: "SEP, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Evanan Romero"],
    links: ["https://youtu.be/2rlxIcfbews"],
  },
  {
    name: "Propuesta para un Desarrollo Forestal Diversificado y sostenible",
    img: "./images/eventplaceholdernull.png",
    day: "13",
    month: "SEP, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["OMAR CARRERO N."],
    links: ["https://youtu.be/DFgAl7VZkEo"],
  },
  {
    name:
      "Análisis del Potencial Energético de Yacimientos No Convencionales en América del Norte y Venezuela.",
    img: "./images/eventplaceholdernull3.png",
    day: "06",
    month: "SEP, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Douglas Betancourt"],
    links: ["https://youtu.be/htP92aRnZsc"],
  },
  {
    name:
      "El Bien y el Mal: la lucha eterna examinada a través de Los Monstruos de la Literatura.",
    img: "./images/eventplaceholdernull.png",
    day: "23",
    month: "AUG, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["María Dolores Ara Díaz"],
    links: ["https://youtu.be/5wzXSm5ij-w"],
  },
  {
    name: "Situación Actual del Mercado Petrolero Mundial",
    img: "./images/eventplaceholdernull3.png",
    day: "16",
    month: "AUG, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Carlos Rossi"],
    links: ["https://youtu.be/MIaJkFOs4dw"],
  },
  {
    name: "Implicaciones de los Resultados Electorales de Venezuela.",
    img: "./images/eventplaceholdernull.png",
    day: "02",
    month: "AUG, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Dr. R. Evan Ellis"],
    links: ["https://youtu.be/pXvujskff54"],
  },
  {
    name:
      "AMPP y su gestión global contra la corrosión. Pasado, presente y futuro para Venezuela",
    img: "./images/eventplaceholdernull3.png",
    day: "26",
    month: "JUL, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Romer Gil"],
    links: ["https://youtu.be/U5kyayw0qTc"],
  },
  {
    name: "Desafíos del Marketing Digital 2024 y Escenarios Futuros",
    img: "./images/eventplaceholdernull2.png",
    day: "19",
    month: "JUL, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Gabriel Angulo y Santiago Rodríguez Reggeti"],
    links: ["https://youtu.be/jI7bRgHvyc8"],
  },
  {
    name:
      "¿CÓMO APROVECHAR EL INCOMPARABLE POTENCIAL ENERGÉTICO DE VENEZUELA PARA PROPULSAR SU DESARROLLO?",
    img: "./images/eventplaceholdernull.png",
    day: "12",
    month: "JUL, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Tomás Mata"],
    links: ["https://youtu.be/K1uU0YmjTTo"],
  },
  {
    name: "El espíritu del 5 de Julio - Venezuela en la Antesala de la Historia",
    img: "./images/eventplaceholdernull3.png",
    day: "05",
    month: "JUL, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Dr. Asdrúbal Aguiar"],
    links: ["https://youtu.be/iNTw3lpKkh8?si=m05MJou8105aEt5P"],
  },
  {
    name: "DISTOPÍAS PROFÉTICAS",
    img: "./images/eventplaceholdernull2.png",
    day: "28",
    month: "JUN, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["María Dolores Ara Díaz"],
    links: ["https://youtu.be/XCbrLzd-M0g"],
  },
  {
    name:
      "Cómo aprender en la era digital usando técnicas de la Inteligencia Artificial",
    img: "./images/eventplaceholdernull.png",
    day: "21",
    month: "JUN, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Jonás Montilva"],
    links: ["https://www.youtube.com/watch?v=ohpuggEyOQ4"],
  },
  {
    name:
      "Más allá de lo Convencional: Evolución y Futuro de los Recursos No Convencionales",
    img: "./images/eventplaceholdernull3.png",
    day: "14",
    month: "JUN, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Oman Oquendo"],
    links: ["https://youtu.be/bbMcLq7IlA8"],
  },
  {
    name: "Venezuela, energía y desarrollo",
    img: "./images/eventplaceholdernull2.png",
    day: "07",
    month: "JUN, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["David Morán"],
    links: ["https://youtu.be/ZFgWSchadkU?si=WF8VA6Mc4xzkSXM0"],
  },
  {
    name:
      "Emprendimiento Social, clave para el crecimiento sostenible de Venezuela",
    img: "./images/eventplaceholdernull.png",
    day: "31",
    month: "MAY, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Medardo Mora"],
    links: ["https://youtu.be/H5j_zZqjdeo?si=gaXLoWBUNBMJ2SUO"],
  },
  {
    name: "La Guerra por el Talento en Venezuela",
    img: "./images/eventplaceholdernull3.png",
    day: "24",
    month: "MAY, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Jesús Castillo"],
    links: [":https://youtu.be/88bM0cWSfhc"],
  },
  {
    name:
      "Posibilidad de apoyo de la DFC al desarrollo futuro económico, social y ambiental de Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "17",
    month: "MAY, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Juan Urich"],
    links: [":https://youtu.be/wNY5eUfDYEs"],
  },
  {
    name: "Inteligencia Artificial Generativa: ¿Cómo aprender en la era digital?",
    img: "./images/eventplaceholdernull.png",
    day: "10",
    month: "MAY, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Jonás A. Montilva C."],
    links: [":https://youtu.be/Uk2H2ElAPXQ"],
  },
  {
    name: "Monetizando tu emprendimiento",
    img: "./images/eventplaceholdernull3.png",
    day: "03",
    month: "MAY, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Edgar Peláez"],
    links: [":https://youtu.be/oR03vqUUenI"],
  },
  {
    name: "La dolarización de la economía venezolana en un nuevo gobierno",
    img: "./images/eventplaceholdernull2.png",
    day: "26",
    month: "ABR, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Gustavo García"],
    links: ["https://youtu.be/4OqIxJQjH9U"],
  },
  {
    name: "Matriz FODA sector energético venezolano",
    img: "./images/eventplaceholdernull.png",
    day: "19",
    month: "ABR, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Elizabeth Cruz"],
    links: ["https://youtu.be/0LYoB9MGKns"],
  },
  {
    name: "Reporte Especial CERAWeek 2024 by S&P Global, Revista Petroleum",
    img: "./images/eventplaceholdernull3.png",
    day: "12",
    month: "ABR, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Jorge Zajía, Edgar Peláez y Carlos Sanchez"],
    links: ["https://youtu.be/RgG-C0wjxtY"],
  },
  {
    name: "Perspectivas de la producción petrolera en Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "05",
    month: "ABR, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Francisco Monaldi"],
    links: ["https://youtu.be/aFXaTeLdTVA"],
  },
  {
    name:
      "Oportunidades de desarrollo del gas natural bajo una nueva concepción política y económica del País",
    img: "./images/eventplaceholdernull.png",
    day: "22",
    month: "MAR, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Evanan Romero, Domingo Marsiccobetre y Jesús Aboud"],
    links: ["https://youtu.be/kTmwxgnj_ns"],
  },
  {
    name: "¿Cómo  apoyar a los estudiantes universitarios venezolanos?",
    img: "./images/eventplaceholdernull3.png",
    day: "15",
    month: "MAR, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 11PM Venezuela",
    presenters: ["Maria Beatriz de Santa Anna y Alfonso Quaglia"],
    links: ["https://youtu.be/W5trFV3l7N8"],
  },
  {
    name: "La Impostergable reinstitucionalización en Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "08",
    month: "MAR, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gonzalo Oliverosz"],
    links: ["https://youtu.be/WGA9fI9_pKM"],
  },
  {
    name: "La Tecnología en la Transición Energética",
    img: "./images/eventplaceholdernull.png",
    day: "01",
    month: "MAR, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Nelson Hernández"],
    links: ["https://youtu.be/_8YWj5McSgg"],
  },
  {
    name: "El programa de gobierno de MCM",
    img: "./images/eventplaceholdernull3.png",
    day: "23",
    month: "FEB, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Rafael de la Cruz"],
    links: ["https://youtu.be/xbY0rcwBvJA"],
  },
  {
    name: "Preguntas y dilemas sobre el presente y futuro de Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "16",
    month: "FEB, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gerver Torres"],
    links: ["https://youtu.be/0fRIlnC-sTQ"],
  },
  {
    name: "Un Vistazo a la Geopolítica en América en 2024",
    img: "./images/eventplaceholdernull.png",
    day: "09",
    month: "FEB, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["David Morán"],
    links: ["https://youtu.be/v0t3ehkNvRc"],
  },
  {
    name: "ESEQUIBO Y SU PETRÓLEO",
    img: "./images/eventplaceholdernull3.png",
    day: "02",
    month: "FEB, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Jesús Aboud"],
    links: ["https://youtu.be/pSqM2cR8eAo"],
  },
  {
    name: "Las verdades de CITGO y el Gobierno Interino",
    img: "./images/eventplaceholdernull2.png",
    day: "26",
    month: "JAN, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Orlando Viera-Blanco"],
    links: [" https://youtu.be/rYFL_HynKrY"],
  },
  {
    name:
      "Fundación Simón Bolívar. Creando impacto, mejorando la salud de los venezolanos",
    img: "./images/eventplaceholdernull.png",
    day: "19",
    month: "JAN, 24",
    year: "2024",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Mariela Poleo"],
    links: [" https://youtu.be/lDjwDOMyumk"],
  },
  {
    name:
      "La ruta para reinventar a Venezuela. PETRÓLEO Piedra Angular del Desarrollo",
    img: "./images/eventplaceholdernull3.png",
    day: "08",
    month: "DIC, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Tomás Mata"],
    links: ["https://www.youtube.com/watch?v=oI7zCkMRVMQ"],
  },
  {
    name:
      "¿Tiene sentido hablar de reservas (como en la industria petrolera) con energías renovables?",
    img: "./images/eventplaceholdernull2.png",
    day: "01",
    month: "DIC, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Enzo Aconcha"],
    links: ["https://youtu.be/O-yebUXSe0E"],
  },
  {
    name: "Así perdimos el Esequibo",
    img: "./images/eventplaceholdernull.png",
    day: "17",
    month: "NOV, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Dr. Asdrúbal Aguiar"],
    links: ["https://youtu.be/RGDYq2zuU3k"],
  },
  {
    name: "El mercado petrolero, una conversación a dos voces",
    img: "./images/eventplaceholdernull3.png",
    day: "10",
    month: "NOV, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Luis Pacheco", "M. Juan Szabo"],
    links: ["https://youtu.be/oQSoNqA5Hjc"],
  },
  {
    name: "Seguridad Psicológica",
    img: "./images/eventplaceholdernull2.png",
    day: "03",
    month: "NOV, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Miguel González"],
    links: ["https://www.youtube.com/watch?v=Ey3DuuoSoaw"],
  },
  {
    name: "Geopolítica Energética",
    img: "./images/eventplaceholdernull.png",
    day: "27",
    month: "OCT, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Ricardo Colmenter"],
    links: ["https://www.youtube.com/watch?v=4Su6BKIU3Jw"],
  },
  {
    name: "Esquemas de desarrollo de la energía geotérmica",
    img: "./images/eventplaceholdernull3.png",
    day: "20",
    month: "OCT, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Reinaldo Ramírez"],
    links: ["https://www.youtube.com/watch?v=KKs_9qLIlAI"],
  },
  {
    name: "EL UMBRAL CUÁNTICO",
    img: "./images/eventplaceholdernull2.png",
    day: "13",
    month: "OCT, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Eleodoro Ventocilla"],
    links: ["https://www.youtube.com/watch?v=g5tHdofdLfU"],
  },
  {
    name:
      "Recuperación del bienestar colectivo en Venezuela y rol de las energías vía autopista o carretera",
    img: "./images/eventplaceholdernull.png",
    day: "06",
    month: "OCT, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gustavo García"],
    links: ["https://www.youtube.com/watch?v=QKnyk54N6Kg"],
  },
  {
    name: "Francisco de Miranda, la Libertad y los Estados Unidos",
    img: "./images/eventplaceholdernull3.png",
    day: "29",
    month: "SEP, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Luis Xavier Grisanti"],
    links: ["https://www.youtube.com/watch?v=n6qcC04qayk"],
  },
  {
    name: "Propuesta de Programa Energético para Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "22",
    month: "SEP, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Eduardo Betancourt"],
    links: ["https://www.youtube.com/watch?v=IaHuQMGuH34"],
  },
  {
    name: "La privatización de facto de PDVSA y la crisis de Citgo",
    img: "./images/eventplaceholdernull.png",
    day: "15",
    month: "SEP, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["José Ignacio Hernández"],
    links: ["https://www.youtube.com/watch?v=-ym3pt04-Vw"],
  },
  {
    name: "Aspectos legales de la Transformación Digital en Petróleo y Gas",
    img: "./images/eventplaceholdernull2.png",
    day: "8",
    month: "SEP, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gabriela Rachadell de Delgado"],
    links: ["https://www.youtube.com/watch?v=Y9zVLBbILsk"],
  },
  {
    name: "Crecimiento, energía y ambiente en la encrucijada",
    img: "./images/eventplaceholdernull.png",
    day: "01",
    month: "SEP, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Antonio Vincentelli"],
    links: ["https://www.youtube.com/watch?v=ad281Oh3G4Y"],
  },
  {
    name:
      "Energía post dictadura 2025 2031 y plan de recuperación de dos décadas perdidas",
    img: "./images/eventplaceholdernull3.png",
    day: "25",
    month: "AUG, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Evanan Romero"],
    links: ["https://www.youtube.com/watch?v=DgOxqw-s7vw"],
  },
  {
    name:
      "Prospects for Venezuelan Debt Restructuring and Economic Reconstruction",
    img: "./images/eventplaceholdernull2.png",
    day: "18",
    month: "AUG, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Steven T. Kargman"],
    links: ["https://www.youtube.com/watch?v=doQDllNWzpw"],
  },
  {
    name: "¿Cómo traer luz al Zulia?",
    img: "./images/eventplaceholdernull.png",
    day: "11",
    month: "AUG, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Tomás Mata"],
    links: ["https://www.youtube.com/watch?v=O0CIM2ZJG1I"],
  },
  {
    name:
      "Necesidades Energéticas de Venezuela Transformando con Visión de Futuro",
    img: "./images/eventplaceholdernull3.png",
    day: "04",
    month: "AUG, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Alvaro Yaber"],
    links: ["https://youtu.be/p0_YcYa3gt0"],
  },
  {
    name: "Economía del Hidrógeno y rol del Almacenamiento Geológico",
    img: "./images/eventplaceholdernull2.png",
    day: "28",
    month: "JUL, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Lorena Moscardelli"],
    links: ["https://youtu.be/Teiad_zbiQ4"],
  },
  {
    name: "Proceso de Internacionalización",
    img: "./images/eventplaceholdernull.png",
    day: "21",
    month: "JUL, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Luis Xavier Grisanti"],
    links: ["https://www.youtube.com/watch?v=bZmJ0Z5pOGM"],
  },
  {
    name: "Gas natural de Venezuela: Retos y Oportunidades con Trinidad y Tobago",
    img: "./images/eventplaceholdernull3.png",
    day: "14",
    month: "JUL, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Horacio Medina"],
    links: ["https://www.youtube.com/watch?v=_qrX_sHdEwk"],
  },
  {
    name: "¿Qué está pasando en Citgo?",
    img: "./images/eventplaceholdernull2.png",
    day: "07",
    month: "JUL, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Horacio Medina"],
    links: ["https://www.youtube.com/watch?v=rHVta8DxPi4"],
  },
  {
    name:
      "Potencial del sector forestal para la mitigación del cambio climático en Venezuela",
    img: "./images/eventplaceholdernull.png",
    day: "30",
    month: "JUN, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["José Rafael Lozada"],
    links: ["https://www.youtube.com/watch?v=nRiv0WBuiTg"],
  },
  {
    name: "Energía, política, pobreza y sostenibilidad",
    img: "./images/eventplaceholdernull3.png",
    day: "23",
    month: "JUN, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Eduardo Betancourt"],
    links: ["https://www.youtube.com/watch?v=1uhjBzXJ6-0"],
  },
  {
    name:
      "Venezuela: Polo Energético e Industrial de Bajas Emisiones de las Américas",
    img: "./images/eventplaceholdernull2.png",
    day: "17",
    month: "JUN, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Lino Carrillo"],
    links: ["https://www.youtube.com/watch?v=s_OIWI_m3aM"],
  },
  {
    name: "Perspectivas Económicas de Venezuela",
    img: "./images/eventplaceholdernull.png",
    day: "09",
    month: "JUN, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Luis Oliveros"],
    links: ["https://www.youtube.com/watch?v=tydl-4jvAl8"],
  },
  {
    name: "Toma de Decisiones Multi criterio en la industria de Petróleo y Gas",
    img: "./images/eventplaceholdernull3.png",
    day: "02",
    month: "JUN, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Asdrúbal Perozo"],
    links: ["https://www.youtube.com/watch?v=0t4Pekjyt48"],
  },
  {
    name: "Responsabilidad social de nuestra industria petrolera 1920-2022",
    img: "./images/eventplaceholdernull2.png",
    day: "26",
    month: "MAY, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Eddie Ramirez"],
    links: ["https://www.youtube.com/watch?v=1uhjBzXJ6-0"],
  },
  {
    name:
      "Venezuela y su relación con los hidrocarburos, el juego cambia de “Suma Cero” a “Suma Positiva “. Nuevo Marco Fiscal",
    img: "./images/eventplaceholdernull.png",
    day: "19",
    month: "MAY, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Javier Rodríguez"],
    links: ["https://www.youtube.com/watch?v=bFI63EEIaMA"],
  },
  {
    name: "Planificación del Desarrollo de Campos de Petróleo y Gas",
    img: "./images/eventplaceholdernull3.png",
    day: "12",
    month: "MAY, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Claudio Martínez"],
    links: ["https://www.youtube.com/watch?v=BJK8qFU5d-8"],
  },
  {
    name: "Qué hacer con la industria petrolera",
    img: "./images/eventplaceholdernull2.png",
    day: "05",
    month: "MAY, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Rafael Gallegos"],
    links: ["https://www.youtube.com/watch?v=QPDTHvfArb8"],
  },
  {
    name: "Hidrocarburos, nuevo orden y descarbonización",
    img: "./images/eventplaceholdernull.png",
    day: "21",
    month: "APR, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Luis Xavier Grisanti"],
    links: ["https://www.youtube.com/watch?v=9IrGpw4kLZk"],
  },
  {
    name:
      "Sector Energético Venezolano: ¿Cómo lograr claridad de acción? ¿Cómo llegar a un acuerdo?",
    img: "./images/eventplaceholdernull3.png",
    day: "14",
    month: "APR, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Víctor Vázquez", "Lino Carrillo"],
    links: ["https://www.youtube.com/watch?v=wURy9K7qnf0"],
  },
  {
    name: "La Liturgia Petrolera",
    img: "./images/eventplaceholdernull2.png",
    day: "31",
    month: "MAR, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Luis Pacheco"],
    links: ["https://www.youtube.com/watch?v=wURy9K7qnf0"],
  },
  {
    name: "¿Invertir en un Activo Petrolífero?",
    img: "./images/eventplaceholdernull.png",
    day: "24",
    month: "MAR, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Oman Oquendo"],
    links: ["https://www.youtube.com/watch?v=TaF7deFEbI8"],
  },
  {
    name: "Son los hidrocarburos una maldición o una bendición para el mundo?",
    img: "./images/eventplaceholdernull3.png",
    day: "17",
    month: "MAR, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Julián Salazar Velásquez"],
    links: ["https://www.youtube.com/watch?v=AEXo8fRJYAA"],
  },
  {
    name: "Campo Zuata-RETOS PARA LA EVENTUAL REACTIVACIÓN",
    img: "./images/eventplaceholdernull2.png",
    day: "10",
    month: "MAR, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Adriano Celli"],
    links: ["https://www.youtube.com/watch?v=Sqv_5m4avEs"],
  },
  {
    name: "La Nacionalización Petrolera en la Gran Venezuela",
    img: "./images/eventplaceholdernull.png",
    day: "03",
    month: "MAR, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gerardo Lucas"],
    links: ["https://www.youtube.com/watch?v=1oZanBRQCgE"],
  },
  {
    name: "Petróleo y sociedad venezolana: una conexión distante",
    img: "./images/eventplaceholdernull3.png",
    day: "24",
    month: "FEB, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Guillermo Guzmán Mirabal"],
    links: ["https://www.youtube.com/watch?v=jX4nI8mC-W4"],
  },
  {
    name: "Venezuela, energía y post socialismo",
    img: "./images/eventplaceholdernull2.png",
    day: "17",
    month: "FEB, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["David Morán Bohórquez"],
    links: ["https://www.youtube.com/watch?v=fcjpi8oi3ag"],
  },
  {
    name:
      "Transición energética, los ESG’s y los desafíos competitivos. Una visión regional",
    img: "./images/eventplaceholdernull.png",
    day: "09",
    month: "FEB, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Fernando H. Branger G."],
    links: ["https://www.youtube.com/watch?v=uUEs13rOtZQ"],
  },
  {
    name: "Una Fábrica de Ciudadanos, Bases para la reconstrucción de Venezuela",
    img: "./images/eventplaceholdernull3.png",
    day: "03",
    month: "FEB, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gustavo Coronel"],
    links: ["https://www.youtube.com/watch?v=HAi7smbtdkQ"],
  },
  {
    name: "Visión del Sistema Eléctrico Nacional",
    img: "./images/eventplaceholdernull2.png",
    day: "27",
    month: "JAN, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gustavo González", "Alberto De Lima"],
    links: ["https://www.youtube.com/watch?v=XNQn78K5Jjo"],
  },
  {
    name: "Comunicación No Violenta",
    img: "./images/eventplaceholdernull.png",
    day: "21",
    month: "JAN, 23",
    year: "2023",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["María E. Garassini"],
    links: ["https://www.youtube.com/watch?v=t59tQNitsYI"],
  },
  {
    name: "La licencia de Chevron",
    img: "./images/eventplaceholdernull3.png",
    day: "09",
    month: "DEC, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Evanán Romero", "Rafael Gallegos", "Horacio Medina"],
    links: ["https://www.youtube.com/watch?v=xLWXehhN31w"],
  },
  {
    name: "Integrating Behind-the-Meter Solar Power In Upstream O&G Operations",
    img: "./images/eventplaceholdernull.png",
    day: "02",
    month: "DEC, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Alonzo A. Alvarez", "Ricardo Rangel (Chevron)"],
    links: ["https://www.youtube.com/watch?v=z9Q09d0X4MA&t=1s"],
  },
  {
    name: "La iniciativa latinoamericana y del Caribe para el mercado de carbono",
    img: "./images/eventplaceholdernull3.png",
    day: "18",
    month: "NOV, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12PM Venezuela",
    presenters: ["Gladis Genua"],
    links: ["https://www.youtube.com/watch?v=K7RK4n4JW-c"],
  },
  {
    name: "Permitiremos que se pierda CITGO?",
    img: "./images/eventplaceholdernull2.png",
    day: "11",
    month: "NOV, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - 12AM Venezuela",
    presenters: ["Horacio Medina"],
    links: ["https://www.youtube.com/watch?v=Dw8eHA9LSlI"],
  },
  {
    name: "La OPEP por dentro",
    img: "./images/eventplaceholdernull.png",
    day: "04",
    month: "NOV, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET/Venezuela)",
    presenters: ["Humberto Calderón Berti"],
    links: ["https://www.youtube.com/watch?v=zAvnlU1bE00"],
  },
  {
    name: "La Creación de Mundos",
    img: "./images/eventplaceholdernull3.png",
    day: "28",
    month: "OCT, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET/Venezuela)",
    presenters: ["Eleodoro Ventocilla"],
    links: ["https://www.youtube.com/watch?v=5XzzWTcpIrU"],
  },
  {
    name: "Industrialización y Desindustrialización de Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "21",
    month: "OCT, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 09AM (CT) - 10AM (ET) - Caracas 11AM",
    presenters: ["Gerardo Lucas"],
    links: ["https://www.youtube.com/watch?v=FyK8gP-udvw"],
  },
  {
    name:
      "Traspasando las fronteras: Como hacer oír la voz del Sector de Energía en Venezuela y el mundo",
    img: "./images/eventplaceholdernull.png",
    day: "14",
    month: "OCT, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Eduardo Betancourt"],
    links: ["https://www.youtube.com/watch?v=p-78PsNpYYU"],
  },
  {
    name: "Cambio Climático  la Realidad, lo Inevitable y Futuros Posibles",
    img: "./images/eventplaceholdernull3.png",
    day: "07",
    month: "OCT, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Fernando Miralles-Wilhelm"],
    links: ["https://youtu.be/z9y8SWQ3FFQ"],
  },
  {
    name: "Claves para Encender el Aparato Productivo",
    img: "./images/eventplaceholdernull2.png",
    day: "30",
    month: "SEP, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Tomás Mata"],
    links: ["https://youtu.be/8_Ga1n4aWiM"],
  },
  {
    name: "El papel de los petroleros en la Reconstrucción de Venezuela",
    img: "./images/eventplaceholdernull.png",
    day: "23",
    month: "SEP, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Humberto Calderón Berti"],
    links: ["https://youtu.be/OSjlQ309jBg"],
  },
  {
    name: "Un Nuevo comienzo. Las Exportaciones Venezolanas",
    img: "./images/eventplaceholdernull3.png",
    day: "16",
    month: "SEP, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Ricardo Cordido Martínez"],
    links: ["https://youtu.be/F1ftSCSYi6k"],
  },
  {
    name: "México: Contexto Actual e Incertidumbre",
    img: "./images/eventplaceholdernull2.png",
    day: "09",
    month: "SEP, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Lucía Bustamante"],
    links: ["https://youtu.be/ek0A2fulNwU"],
  },
  {
    name: "El logro de la felicidad",
    img: "./images/eventplaceholdernull.png",
    day: "02",
    month: "SEP, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Jon Aizpúrua"],
    links: ["https://youtu.be/cUR0FO3xPF0"],
  },
  {
    name: "CITGO: VALOR DEL MAÑANA ESFUERZO DE HOY",
    img: "./images/eventplaceholdernull3.png",
    day: "26",
    month: "AUG, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Horacio Medina"],
    links: ["https://youtu.be/Vo41xhFXEXo"],
  },
  {
    name:
      "Consideraciones sobre los gases de efecto invernadero en la industria petrolera",
    img: "./images/eventplaceholdernull2.png",
    day: "19",
    month: "AUG, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Herman Rojas"],
    links: ["https://youtu.be/TtFVqJ-INJ0"],
  },
  {
    name:
      "El bloqueo de las potencias europeas a Venezuela en tiempos de Cipriano Castro",
    img: "./images/eventplaceholdernull.png",
    day: "12",
    month: "AUG, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Javier Escala Porras"],
    links: ["https://youtu.be/e1s4o15NG-E"],
  },
  {
    name: "¿Realmente tiene Venezuela las mayores reservas petroleras del mundo?",
    img: "./images/eventplaceholdernull3.png",
    day: "05",
    month: "AUG, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Julián Salazar Velásquez"],
    links: ["https://youtu.be/lUUuKapb2rg"],
  },
  {
    name:
      "Gas Natural e Industria  Siderúrgica en un entorno de Emisiones neutras 2050",
    img: "./images/eventplaceholdernull2.png",
    day: "29",
    month: "JUL, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Víctor Vázquez"],
    links: ["https://youtu.be/hw4juZtzwJk"],
  },
  {
    name: "Doce competencias y su pertinencia en un mundo orgánico",
    img: "./images/eventplaceholdernull.png",
    day: "22",
    month: "JUL, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Arnaldo Gonzalez"],
    links: ["https://youtu.be/9u0H-h5b13s"],
  },
  {
    name: "La siembra de la pobreza",
    img: "./images/eventplaceholdernull3.png",
    day: "15",
    month: "JUL, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Arquímedes Román"],
    links: ["https://youtu.be/5K5Dzj8h3EA"],
  },
  {
    name:
      "Rendición de Cuentas 2021–1T2022 PDVSA Ad Hoc  CUMPLIENDO CON VENEZUELA",
    img: "./images/eventplaceholdernull2.png",
    day: "08",
    month: "JUL, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Horacio Medina"],
    links: ["https://youtu.be/sHvVgHXjfuM"],
  },
  {
    name: "Los monstruos de la literatura",
    img: "./images/eventplaceholdernull.png",
    day: "01",
    month: "JUL, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["María Dolores Ara"],
    links: ["https://youtu.be/I0gU3EtE0Bw"],
  },
  {
    name: "Aspectos sobre la Participación Fiscal de los HC en Venezuela",
    img: "./images/eventplaceholdernull3.png",
    day: "24",
    month: "JUN, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Jesus M. Aboud"],
    links: ["https://youtu.be/xESHLqEMLeE"],
  },
  {
    name: "Industria Eléctrica Venezolana: Transformación con Visión de Futuro",
    img: "./images/eventplaceholdernull.png",
    day: "17",
    month: "JUN, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Álvaro Yabel"],
    links: ["https://www.youtube.com/watch?v=IpMf_PgHRQY"],
  },
  {
    name: "AMÉRICA, ¿A DÓNDE VAS?",
    img: "./images/eventplaceholdernull3.png",
    day: "10",
    month: "JUN, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: [
      "Humberto Calderón",
      "Milos Alcalay",
      "Diego Arria",
      "Oracio medina",
    ],
    links: ["https://www.youtube.com/watch?v=jLbRVRUbazk"],
  },
  {
    name:
      "Energy Security and Decarbonization Shifting Priorities in U S Energy Policy",
    img: "./images/eventplaceholdernull2.png",
    day: "03",
    month: "JUN, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Jack Belcher"],
    links: ["https://www.youtube.com/watch?v=y5pdhtOydRA&t=11s"],
  },
  {
    name: "Orimulsión: pasado presente futuro",
    img: "./images/eventplaceholdernull.png",
    day: "27",
    month: "MAY, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Carlos Borregales Loaiza"],
    links: ["https://www.youtube.com/watch?v=j581HeaQD-I"],
  },
  {
    name: "El logro de la felicidad",
    img: "./images/eventplaceholdernull3.png",
    day: "20",
    month: "MAY, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Jon Aizpúrua"],
    links: ["https://meet.goto.com/522683485"],
  },
  {
    name:
      "Proyecto Calidad de Yacimientos Terrígenos de las márgenes Caribe y Pacifico de Colombia",
    img: "./images/eventplaceholdernull2.png",
    day: "13",
    month: "MAY, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Victor Ramírez"],
    links: ["https://www.youtube.com/watch?v=usBr5rfwjAg"],
  },
  {
    name: "Geopolítica Petrolera",
    img: "./images/eventplaceholdernull.png",
    day: "06",
    month: "MAY, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Humberto Calderón Berti"],
    links: ["https://www.youtube.com/watch?v=_TbQwPMHThU"],
  },
  {
    name: "Pre-OTC International Cocktail 2022",
    img: "./images/eventplaceholdernull.png",
    day: "01",
    month: "MAY, 22",
    year: "2022",
    type: "Special Event",
    time: "Su 06:00PM to 09:00PM",
    presenters: [""],
    links: ["https://argentinatexas.org/event-4755495"],
  },
  {
    name:
      "Conversatorio con Maxim Ross sobre: El fin de Petrolia y una nueva Venezuela",
    img: "./images/eventplaceholdernull3.png",
    day: "29",
    month: "APR, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Maxim Ross"],
    links: ["https://www.youtube.com/watch?v=hX6z-Dt9jjg"],
  },
  {
    name:
      "Los logros de la Meritocracia Petrolera, Lecciones para el futuro de la Industria",
    img: "./images/eventplaceholdernull2.png",
    day: "22",
    month: "APR, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Rafael Gallegos"],
    links: ["https://www.youtube.com/watch?v=WuOA_Pjyl6g"],
  },
  {
    name: "Rómulo Gallegos / La rebelión",
    img: "./images/eventplaceholdernull.png",
    day: "08",
    month: "APR, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["María Dolores Ara"],
    links: ["https://www.youtube.com/watch?v=du_BrvuqM_M"],
  },
  {
    name:
      "La Petroquímica como un elemento para el desarrollo sustentable de Venezuela, en el Marco de la Transición Energética",
    img: "./images/eventplaceholdernull3.png",
    day: "01",
    month: "APR, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["José Castor González"],
    links: ["https://www.youtube.com/watch?v=2A6bqzpkd6A"],
  },
  {
    name: "Experiencia Educativa: El Caso de Japón",
    img: "./images/eventplaceholdernull2.png",
    day: "25",
    month: "MAR, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Ingrid Betancourt"],
    links: ["https://www.youtube.com/watch?v=8MYMXjQ95TQ"],
  },
  {
    name:
      "Alternativa Nuclear Dentro del Panorama Energético Global y Situación de Venezuela",
    img: "./images/eventplaceholdernull.png",
    day: "18",
    month: "MAR, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Rafael Martín"],
    links: ["https://www.youtube.com/watch?v=qvCs8oqIkFM"],
  },
  {
    name:
      "¿Es este el peor momento de nuestra historia? La coyuntura venezolana actual en perspectiva histórica",
    img: "./images/eventplaceholdernull.png",
    day: "11",
    month: "MAR, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Inés Quintero"],
    links: ["https://www.youtube.com/watch?v=ic5NP_EqAmk"],
  },
  {
    name: "Hydrocarbon Producers and the Path to Net Zero 2050",
    img: "./images/eventplaceholdernull3.png",
    day: "04",
    month: "MAR, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Jessica Franquiz"],
    links: ["https://www.youtube.com/watch?v=srqXUASSHek"],
  },
  {
    name:
      "Proyecto Uverito (Venezuela) un sumidero de Carbono del CO2 atmosférico",
    img: "./images/eventplaceholdernull2.png",
    day: "25",
    month: "FEB, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Juan F. Urich Portet", "Héctor Canales"],
    links: ["https://www.youtube.com/watch?v=Fqnj3qmtH7c&t=1619s"],
  },
  {
    name: "El fin de Petrolia y una nueva Venezuela",
    img: "./images/eventplaceholdernull.png",
    day: "18",
    month: "FEB, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Maxim Rose"],
    links: ["https://www.youtube.com/watch?v=mPMs3unKKZw"],
  },
  {
    name: "Cambio organizacional para el mejoramiento de la productividad",
    img: "./images/eventplaceholdernull3.png",
    day: "11",
    month: "FEB, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Luis S. Vilora"],
    links: ["https://www.youtube.com/watch?v=xXRpdsAkG1o"],
  },
  {
    name: "Ideas para la Venezuela del Futuro",
    img: "./images/eventplaceholdernull2.png",
    day: "04",
    month: "FEB, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Emilio Venuti"],
    links: ["https://www.youtube.com/watch?v=HgkRTcnNz0M&t=27s"],
  },
  {
    name:
      "Casas Muertas La promesa de resurrección.  Una relectura de la novela de Miguel Otero Silva",
    img: "./images/eventplaceholdernull.png",
    day: "28",
    month: "JAN, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Milagros Socorro"],
    links: ["https://youtu.be/mjDf-ReW4Io"],
  },
  {
    name:
      "El talento humano en la recuperación de la Industria Energética Venezolana",
    img: "./images/eventplaceholdernull2.png",
    day: "14",
    month: "JAN, 22",
    year: "2022",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET) - Caracas 12PM",
    presenters: ["Héctor Riquezes", "Nelsón Olmedillo", "Eduardo Betancourt"],
    links: ["https://youtu.be/pS4Yj6SHgaY"],
  },
  {
    name: "CAREER AND TECHNICAL MENTORSHIP PROGRAM",
    img: "./images/events/mentorship.jpeg",
    day: "31",
    month: "DEC, 03",
    year: "2021",
    type: "Online",
    time: "",
    presenters: [],
    links: ["mentorship.html"],
  },
  {
    name:
      "La transición Energética, Plataforma para la nueva gran expansión de Venezuela",
    img: "./images/eventplaceholdernull3.png",
    day: "03",
    month: "DEC, 03",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Tomas Mata"],
    links: ["https://youtu.be/me2HbhmT5Uc"],
  },
  {
    name:
      "PROTECCIÓN AMBIENTAL EN LA IPN: LO QUE LOGRAMOS Y UNA PROPUESTA CONCEPTUAL PARA LA ACCIÓN FUTURA",
    img: "./images/eventplaceholdernull.png",
    day: "19",
    month: "NOV, 19",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Juan F Urich", "Sergio R Alcalá"],
    links: [""],
  },
  {
    name: "Venezuela: La Transición Energética y Energías Renovables",
    img: "./images/eventplaceholdernull3.png",
    day: "12",
    month: "NOV, 12",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Nelson Hernández"],
    links: [""],
  },
  {
    name: "Gerencia de crisis, liderar en desafíos",
    img: "./images/eventplaceholdernull2.png",
    day: "05",
    month: "NOV, 05",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Arnaldo Rodríguez"],
    links: ["https://youtu.be/IlMU3-fUMFY"],
  },
  {
    name:
      "La Economía del Hidrógeno y la Importancia del Almacenamiento en el Subsuelo",
    img: "./images/eventplaceholdernull.png",
    day: "22",
    month: "OCT, 22",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Lorena Moscardelli"],
    links: ["https://youtu.be/-rf5c3Qe98g"],
  },
  {
    name: "SPE-GCS Hiring Event",
    img: "./images/events/linkedin-event.jpeg",
    day: "12",
    month: "OCT, 12",
    year: "2021",
    type: "Special Event",
    time: "THU-FRI 08:00AM - 04:00PM (CT)",
    presenters: [""],
    links: [
      "https://www.linkedin.com/posts/spe-gcs-hiring-event_spegcshiringevent-hiring-opportunity-activity-6841485861008351232-Byzq",
    ],
  },
  {
    name: "La Geotermia, La renovable más afín a la Industria del Petróleo",
    img: "./images/eventplaceholdernull3.png",
    day: "08",
    month: "OCT, 08",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Reinaldo Ramirez"],
    links: ["https://youtu.be/AsTmpSwQlf8"],
  },
  {
    name: "Campo Jay-Lec, un buen ejemplo de una exitosa gerencia de yacimientos",
    img: "./images/eventplaceholdernull3.png",
    day: "01",
    month: "OCT, 01",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Ricardo Padrón"],
    links: ["https://youtu.be/eeOv6tpVM2w"],
  },
  {
    name: 'PROYECTO "SOSTENIBILIDAD"',
    img: "./images/events/sustainability.png",
    day: "Soon",
    month: "SEP, 24",
    year: "2021",
    type: "Special Event",
    time: "THU-FRI 08:15AM - 12:30PM (CT)",
    presenters: [""],
    links: ["sustainability.html"],
  },
  {
    name: "Reinserción de Venezuela en los mercados de crudos: Una teoría",
    img: "./images/eventplaceholdernull3.png",
    day: "24",
    month: "SEP, 24",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Tyrone Perdomo"],
    links: ["https://youtu.be/sVecMhRbnqU"],
  },
  {
    name:
      "Las dos grandes amenazas actuales  a la industria petrolera : el antifracking y el calentamiento global",
    img: "./images/eventplaceholdernull2.png",
    day: "17",
    month: "SEP, 17",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Julian Salazar"],
    links: ["https://youtu.be/sVecMhRbnqU"],
  },
  {
    name:
      "Retos para integrar el petróleo a la economía circular de los plásticos",
    img: "./images/eventplaceholdernull.png",
    day: "10",
    month: "SEP, 10",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Freddy Goerke García"],
    links: ["https://global.gotomeeting.com/join/767711269"],
  },
  {
    name:
      "Tecnologías para Incremento de Recobro y Mejoramiento In Situ de Crudos Pesados",
    img: "./images/eventplaceholdernull3.png",
    day: "03",
    month: "SEP, 03",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Pedro Pereira"],
    links: ["https://youtu.be/qcxiIy6Jeik"],
  },
  {
    name: "Fundamentos de la Gerencia del Cambio",
    img: "./images/eventplaceholdernull2.png",
    day: "27",
    month: "AUG, 27",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Eduardo Betancourt"],
    links: ["https://youtu.be/dYwcDIzEN94"],
  },
  {
    name:
      "La ética en una nueva cultura organizacional para la Industria Energética Venezolana",
    img: "./images/eventplaceholdernull.png",
    day: "20",
    month: "AUG, 20",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Vinicio Semprún"],
    links: ["https://youtu.be/2aV6Frd8eW0"],
  },
  {
    name:
      "Herramientas para fortalecer el Liderazgo Propositivo ante la nueva realidad organizacional",
    img: "./images/eventplaceholdernull3.png",
    day: "13",
    month: "AUG, 13",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Ángel Ceballos"],
    links: ["https://youtu.be/ASoBRmdiKso"],
  },
  {
    name: "Gerencia integrada de yacimientos",
    img: "./images/eventplaceholdernull2.png",
    day: "06",
    month: "AUG, 06",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Claudio Martínez"],
    links: ["https://youtu.be/1M9RdfAQzk4"],
  },
  {
    name: "New and Improved In-situ Recovery Methods for Oil Sands and Heavy Oil",
    img: "./images/eventplaceholdernull1.png",
    day: "30",
    month: "JUL, 30",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Dr Thomas Harding"],
    links: ["https://youtu.be/iGgL2Wk6crQ"],
  },
  {
    name: "La Transición Energética y su impacto en la Ingeniería de Petróleo",
    img: "./images/eventplaceholdernull.png",
    day: "23",
    month: "JUL, 23",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Nelson Hernández"],
    links: ["https://youtu.be/twP4p5JhLFE"],
  },
  {
    name: "ESG y otros acrónimos claves para petróleo y gas",
    img: "./images/events/jul162021.png",
    day: "16",
    month: "JUL, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["María Ángela Capello"],
    links: ["https://global.gotomeeting.com/join/671481605"],
  },
  {
    name: "Aprendizajes para avanzar",
    img: "./images/eventplaceholdernull2.png",
    day: "9",
    month: "JUL, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Luis Pulgar"],
    links: ["https://global.gotomeeting.com/join/325279629"],
  },
  {
    name: "Béisbol en tiempos de Transformación",
    img: "./images/eventplaceholdernull3.png",
    day: "2",
    month: "JUL, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Claudio Martínez"],
    links: ["https://global.gotomeeting.com/join/398741533"],
  },
  {
    name: "Mega Tendencias, Mega Realidades y Mega Rupturas: 2040",
    img: "./images/eventplaceholdernull1.png",
    day: "25",
    month: "JUN, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Antonio Vincentelli"],
    links: ["https://global.gotomeeting.com/join/129930029"],
  },
  {
    name: "Caracterización de Yacimientos Fracturados Complejos",
    img: "./images/eventplaceholdernull.png",
    day: "18",
    month: "JUN, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["José Guzmán"],
    links: ["https://global.gotomeeting.com/join/838961213"],
  },
  {
    name:
      "La IV Revolución Industrial y el Paradigma Emergente en la Gestión de RR.HH",
    img: "./images/events/jun112021.png",
    day: "11",
    month: "JUN, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Paul Rosillón"],
    links: ["https://global.gotomeeting.com/join/954816125"],
  },
  {
    name: "First EAGE/VAPA Online Forum: Venezuela's Upstream to Downstream ",
    img: "./images/events/eage-vapa-JUN.jpeg",
    day: "3-4",
    month: "JUN, 21",
    year: "2021",
    type: "Special Event",
    time: "THU-FRI 08:15AM - 12:30PM (CT)",
    presenters: [""],
    links: [
      "https://eage.eventsair.com/first-eagevapa-online-forum-venezuelas-upstream-to-downstream-past-present-and-future/",
    ],
  },
  {
    name: "Venezuela: Energy Solutions for the future",
    img: "./images/events/april2021.png",
    day: "",
    month: "",
    year: "2021",
    type: "Webinar",
    time: "Online Final",
    presenters: [""],
    links: ["https://www.venezuelaenergy.org/"],
  },
  {
    name: "La Industria Energética: Plataforma para la Prosperidad de Venezuela",
    img: "./images/events/may282021.png",
    day: "28",
    month: "MAY, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Tomas Mata"],
    links: ["https://youtu.be/W3TxpIAHh9s"],
  },
  {
    name: "Interpretar y Actuar en el Mundo de Hoy",
    img: "./images/events/may212021.png",
    day: "21",
    month: "MAY, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Sergio Maggiolo"],
    links: ["https://youtu.be/eu0dSfA4F4Q"],
  },
  {
    name: "Sostenibilidad en La Industria de Petróleo y Gas",
    img: "./images/events/may142021.png",
    day: "14",
    month: "MAY, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Irene Petkoff"],
    links: ["https://youtu.be/nnSX-lMrTjw"],
  },
  {
    name:
      "Una visión de los Estados Unidos de América para la Reconstrucción del Sector Energético Venezolano",
    img: "./images/events/may122021.png",
    day: "12",
    month: "MAY, 21",
    year: "2021",
    type: "Webinar",
    time: "Wed 3PM (CT) - 4PM (ET)",
    presenters: ["James Story"],
    links: ["https://youtu.be/nnSX-lMrTjw"],
  },
  {
    name: "El movimiento sindical ante las nuevas realidades",
    img: "./images/eventplaceholdernull2.png",
    day: "30",
    month: "APR, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM (CT) - 11AM (ET)",
    presenters: ["Carlos Ortega", "León Arismendi", "Carlos Henríquez"],
    links: ["https://youtu.be/jgJ4rbFzxOA"],
  },
  {
    name: "El sur del orinóco, el alma económica de Venezuela",
    img: "./images/eventplaceholdernull1.png",
    day: "29",
    month: "APR, 21",
    year: "2021",
    type: "Webinar",
    time: "Thu 10AM (CT) - 11AM (ET)",
    presenters: ["Jorge Trujillo Herrera"],
    links: ["https://youtu.be/l-8NzNWR83M"],
  },
  {
    name: "La felicidad en el trabajo. Trabájate mientras trabajas",
    img: "./images/eventplaceholdernull.png",
    day: "23",
    month: "APR, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Dorian Oria"],
    links: ["https://youtu.be/-aN8XrhZPbI"],
  },
  {
    name: "XVI CONGRESO VENEZOLANO DE GEOFISICA",
    img: "./images/events/feb242621.png",
    day: "24-26",
    month: "FEB, 21",
    year: "2021",
    type: "Online",
    time: "Wed-Fri 10AM - 06PM (CT)",
    presenters: ["SOVG"],
    links: ["specialevent.html"],
  },
  {
    name: "LOS RETOS ORGANIZACIONALES Y DE CAPITAL HUMANO DE LA NUEVA IPN",
    img: "./images/events/feb1221.png",
    day: "12",
    month: "FEB, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Eduardo Betancourt"],
    links: ["https://global.gotomeeting.com/join/630750581"],
  },
  {
    name:
      "SISTEMA INTEGRADO PARA LA GESTIÓN DEL RIESGO EN PROYECTOS DE CAPITAL Y DESMANTELAMIENTO",
    img: "./images/events/jan2221.png",
    day: "22",
    month: "JAN, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Asdrubal Medina"],
    links: ["https://www.youtube.com/watch?v=2BwzqmM1XrU&feature=youtu.be"],
  },
  {
    name:
      "USO DE DATOS SÍSMICOS PARA LA CONSTRUCCIÓN DE MODELOS DE FLUJO EN YACIMIENTOS FRACTURADOS NO CONVENCIONALES",
    img: "./images/events/jan1521.png",
    day: "15",
    month: "JAN, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Dr. Reinaldo Michelena"],
    links: ["https://www.youtube.com/watch?v=ar64fdr0k0Y&feature=youtu.be"],
  },
  {
    name: "SUSTAINABLE ENERGY FOR THE 21ST CENTURY",
    img: "./images/events/jan0821.png",
    day: "08",
    month: "JAN, 21",
    year: "2021",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Dr. Scott Tinker"],
    links: ["https://www.youtube.com/watch?v=RSqJ24HOWjo&feature=youtu.be"],
  },
  {
    name: "LINEAMIENTOS PARA LA RECONSTRUCCION DE LA CADENA FERRO SIDERURGICA",
    img: "./images/events/dec1820.png",
    day: "18",
    month: "DEC, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Victor Vazquez", "Teolindo Yanez e Ivan Sanojas"],
    links: ["https://www.youtube.com/watch?v=du3KgJCvtZ0&feature=youtu.be"],
  },
  {
    name: "REACTIVACION DEL SISTEMA NACIONAL DE REFINACION",
    img: "./images/events/dec1120.png",
    day: "11",
    month: "DEC, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Jorge Kamkoff", "Lino Carrillo y Rene Lucena"],
    links: ["https://www.youtube.com/watch?v=du3KgJCvtZ0&feature=youtu.be"],
  },
  {
    name:
      "REDUCCIÓN DE LA HUELLA DE CO2 MEDIANTE EL MONITOREO GEOFÍSICO DE LOS PROYECTOS DE EOR",
    img: "./images/events/dec0520.png",
    day: "04",
    month: "DEC, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Dr. Herminio Passalacqua"],
    links: ["https://www.youtube.com/watch?v=EG4eLzA34IE&feature=youtu.be"],
  },
  {
    name: "CONTRATACIONES PÚBLICAS TRANSPARENTES",
    img: "./images/events/nov2020.png",
    day: "20",
    month: "NOV, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Victor Hugo Rodriguez", "Oscar Castro Pacheco"],
    links: ["https://www.youtube.com/watch?v=i8AExdv3_Kg"],
  },
  {
    name: "CORONAVIRUS EN TIEMPOS DE CAMBIO",
    img: "./images/events/nov1320.png",
    day: "13",
    month: "NOV, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Dr. Luis Azpurua"],
    links: ["https://www.youtube.com/watch?v=MTXiknctb_o"],
  },
  {
    name:
      "IDEAS PARA REPOSICIONAR A VENEZUELA EN EL NUEVO MAPA ENERGETICO MUNDIAL",
    img: "./images/events/nov0620.png",
    day: "06",
    month: "NOV, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Tomas Mata"],
    links: ["https://www.youtube.com/watch?v=RxXJPmcewS8&feature=youtu.be"],
  },
  {
    name: "ORIGEN Y EVOLUCION DE CITGO",
    img: "./images/events/oct3020.png",
    day: "30",
    month: "OCT, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Carlos Jorda"],
    links: ["#."],
  },
  {
    name: "FORMACION DE CIUDADANOS UTILES, SOLUCION PARA VENEZUELA",
    img: "./images/events/oct2420.png",
    day: "06",
    month: "OCT, 20",
    year: "2020",
    type: "Webinar",
    time: " Sat 10AM - 11AM (CT)",
    presenters: [
      "Hector Riquezes",
      "Marisol Angarita",
      "Hector Rodriguez Manchego",
      "Maria Gabriela Pinto",
    ],
    links: ["https://www.youtube.com/watch?v=Tn15RIPcWE0"],
  },
  {
    name: "IMPORTANCIA DE PLANES DE DESARROLLO DE CAMPOS DE PETROLEO Y GAS",
    img: "./images/events/oct2320.png",
    day: "23",
    month: "OCT, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Julio Herbas"],
    links: ["https://www.youtube.com/watch?v=g-caZhdNI9o"],
  },
  {
    name: "RAZON DE SER",
    img: "./images/events/oct2220.png",
    day: "22",
    month: "OCT, 20",
    year: "2020",
    type: "Webinar",
    time: "Thu 10AM - 11AM (CT)",
    presenters: ["Alejandro Szilagyi"],
    links: ["https://www.youtube.com/watch?v=73GvhXRG9Sc"],
  },
  {
    name: "GERENCIA INTEGRADA DE CAMPOS AGOTADOS",
    img: "./images/events/oct0920.png",
    day: "09",
    month: "OCT, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Julian Salazar"],
    links: ["https://www.youtube.com/watch?v=-c_iRCQndQo"],
  },
  {
    name: "RECONSTRUCCIÓN, PETRÓLEO Y PARTICIPACIÓN NACIONAL",
    img: "./images/events/oct0220.png",
    day: "02",
    month: "OCT, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 10AM - 11AM (CT)",
    presenters: ["Antonio Vicentelli"],
    links: ["https://www.youtube.com/watch?v=0AJRU1xK7cg"],
  },
  {
    name: "FINANCING VENEZUELA OIL SECTOR POST-SANCTION",
    img: "./images/EventPlaceHolder2.png",
    day: "25",
    month: "SEP, 20",
    year: "2020",
    type: "Webinar",
    time: "Fri 11AM - 12PM (CT)",
    presenters: [
      "Ali Moshiri talks about Financing Venezuela Oil Sector Post-Sanction",
    ],
    links: ["#."],
  },
  {
    name: "VAPA - VENAMERICA WEBINAR",
    img: "./images/sep112020.png",
    day: "11",
    month: "SEP, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: [
      "Seguridad en el Proceso de Recuperacion de la Industria Petrolera en Venezuela",
      "",
      "Presentador: John Marulanda",
    ],
    links: ["https://www.youtube.com/watch?v=kddrsGG4mWQ"],
  },
  {
    name: "ESEQUIBO Y STABROEK : ENTRE LINEAS",
    img: "./images/eventplaceholdernull.png",
    day: "28",
    month: "AUG, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Presentador: Milton Mendez"],
    links: ["https://www.youtube.com/watch?v=bEY3k_T4vqo"],
  },
  {
    name: "DIAGNOSTICO Y SEGURIDAD EN VENEZUELA",
    img: "./images/events/eventplaceholdernull2.png",
    day: "21",
    month: "AUG, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Presentador: Ivan Simonovis"],
    links: ["https://www.youtube.com/watch?v=rFNLpZ2-9Po"],
  },
  {
    name: "EL NEGOCIO PETROLERO",
    img: "./images/eventplaceholdernull2.png",
    day: "14",
    month: "AUG, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: [
      "Retos y Oportunidades - Exploración y Producción de Hidrocarburos No-Convencionales",
      "",
      "Presentador: Marcelo LaPrea-Bigott",
    ],
    links: ["https://www.youtube.com/watch?v=BTMzFUNxqlA"],
  },
  {
    name: "Usurpación vs Transición: el dilema venezolano",
    img: "./images/eventplaceholdernull2.png",
    day: "24",
    month: "JUL, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Perkins Rocha"],
    links: ["https://www.youtube.com/watch?v=AOYGREcKSX0"],
  },
  {
    name:
      "Reboot Venezuelan Oil Industry: Lessons from other countries on the role of a Regulator",
    img: "./images/eventplaceholdernull2.png",
    day: "10",
    month: "JUL, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Jan Paul Van Driel", "Adam Mitchel", "Jean-Jacques Lafon"],
    links: ["https://www.youtube.com/watch?v=U-sD-fh0NEY"],
  },
  {
    name:
      "Reforma Energetica Mexicana. Aprendizaje de la CNH y la Industria de la Informacion",
    img: "./images/eventplaceholdernull2.png",
    day: "08",
    month: "JUL, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Jose Pablo Rinkenbach", "Juan Carlos Zepeda", "Oscar Roldan"],
    links: ["https://www.youtube.com/watch?v=zsdmxgNWk5o"],
  },
  {
    name: "Crisis Alimentarias en Venezuela . Propuesta de Superacion",
    img: "./images/eventplaceholdernull2.png",
    day: "03",
    month: "JUL, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: [
      "Alirio Oliveros",
      "Luis Hidalgo Parisca",
      "Orlando Martinez Montilla",
    ],
    links: ["https://www.youtube.com/watch?v=GRfcU2jGM3E"],
  },
  {
    name:
      "Porque Colapso la Industria Petrolera Venezolana: Sobre esas experiencias y el modelo de captura de renta petrolera por parte del tesoro. ¿Qué caminos le restan a Venezuela para volver a ser un país exportador de petróleo?”",
    img: "./images/eventplaceholdernull2.png",
    day: "26",
    month: "JUN, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Alexander  Guerrero"],
    links: ["https://www.youtube.com/watch?v=EKQSqiY_6Xg"],
  },
  {
    name: "ONG Plan Pais: educando y conectando a jóvenes venezolanos",
    img: "./images/eventplaceholdernull2.png",
    day: "24",
    month: "JUN, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Juan Pio Hernandez", "Carlos Ruiz"],
    links: ["https://www.youtube.com/watch?v=k13mMC7o2mg"],
  },
  {
    name: "Al Dia Siguiente",
    img: "./images/eventplaceholdernull2.png",
    day: "19",
    month: "JUN, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Orlando Viera Blanco"],
    links: ["https://www.youtube.com/watch?v=I9hRZls5JPs"],
  },
  {
    name:
      "El Impacto de la Politica Economica y de las Instituciones en el Proceso de Desarrollo Venezolano - Lecciones para la Reconstruccion",
    img: "./images/eventplaceholdernull2.png",
    day: "12",
    month: "JUN, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Miguel Rodriguez"],
    links: ["https://www.youtube.com/watch?v=W85ssbAuVqs"],
  },
  {
    name: "Transition Energetica de Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "05",
    month: "JUN, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Nelson Hernandez"],
    links: ["https://www.youtube.com/watch?v=FnxR4ZyLMJc"],
  },
  {
    name: "Mercado Interno Industria Petrolera Venezolana",
    img: "./images/eventplaceholdernull2.png",
    day: "03",
    month: "JUN, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Ramon Catsro"],
    links: ["https://www.youtube.com/watch?v=GE6QILvOaGI"],
  },
  {
    name: "La Reconstruccion de Venezuela y el Rol de la Industria Petrolera",
    img: "./images/eventplaceholdernull2.png",
    day: "29",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Ricardo Hausmann"],
    links: ["https://youtu.be/aqe8iNdcpgI"],
  },
  {
    name: "La Pandemia y el Petroleo: El Caso de Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "27",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Luis Giusti"],
    links: ["https://www.youtube.com/watch?v=_ORz6GWp9Do"],
  },
  {
    name: "Industria Venezolana de Hidrocarburos .  Regulacion Apropiada ?",
    img: "./images/eventplaceholdernull2.png",
    day: "22",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Cesar Mata Garcia"],
    links: ["https://www.youtube.com/watch?v=mI3BTz09lsc"],
  },
  {
    name: "Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "20",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Miguel Rivero", "Toni"],
    links: ["https://www.youtube.com/watch?v=8KAgielT02M"],
  },
  {
    name:
      "Esquema Integrado de Seguridad Industrial y Ambiente para la reactivacion de la Industria Petrolera Venezolana",
    img: "./images/eventplaceholdernull2.png",
    day: "15",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Jorge Rodriguez Grau", "Luis Pabon"],
    links: ["https://youtu.be/GA3eX1ogvKo"],
  },
  {
    name:
      "La Industria petrolera y gasiferar venezolana del futuro.. Su potenciacion con base en  procesos ,tecnologias , organizacion y gente , y modelos de negocios y contratacion clase mundial",
    img: "./images/eventplaceholdernull2.png",
    day: "13",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: [
      "Freddy Perez",
      "Rafael Paz",
      "Giovanni Hernandez",
      "Adrian Sanchez",
    ],
    links: ["https://www.youtube.com/watch?v=ZJHlAaFVcCo"],
  },
  {
    name: "Plan Táctico de Emergencia para la IPPN",
    img: "./images/eventplaceholdernull2.png",
    day: "08",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Elizabeth Cruz"],
    links: ["https://www.youtube.com/watch?v=SaP8Dz9kkHg"],
  },
  {
    name: "Venezuela : El Desafio del Sector Petrolero",
    img: "./images/eventplaceholdernull2.png",
    day: "06",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Reinaldo Quintero"],
    links: ["https://youtu.be/UBal_vr1BSU"],
  },
  {
    name: "Hacia una Nueva IPN - Tiempo de Nuevas Ideas",
    img: "./images/eventplaceholdernull2.png",
    day: "01",
    month: "MAY, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Luis Pacheco", "Juan Szabo"],
    links: [
      "https://youtu.be/UBal_vr1BSU",
      "https://www.youtube.com/watch?v=ZJHlAaFVcCo",
    ],
  },
  {
    name: "La nueva LOH Mitos y Realidades",
    img: "./images/eventplaceholdernull2.png",
    day: "29",
    month: "APR, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Luis Stefanelli"],
    links: [
      "https://youtu.be/32uRtz8n7YU",
      "https://youtu.be/K8jSIyS7OCo",
      "https://www.youtube.com/watch?v=TLYDJE2r1lA",
    ],
  },
  {
    name:
      "Un Nuevo Marco Institucional, Fiscal y Contractual para la Industria Petrolera Venezolana",
    img: "./images/eventplaceholdernull2.png",
    day: "24",
    month: "APR, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Francisco Monaldi"],
    links: [
      "https://youtu.be/LkITFobgISw",
      "https://www.youtube.com/watch?v=FvtO1iYkMoQ",
    ],
  },
  {
    name:
      "Problematica del Suministro de Combustible al Mercado Interno de Venezuela",
    img: "./images/eventplaceholdernull2.png",
    day: "22",
    month: "APR, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: [
      "Jorge Kamkoff",
      "Rene Lucena",
      "Francois Raineau",
      "Rene Lucene",
      "Francois Raineau",
    ],
    links: [
      "https://youtu.be/y0NOTy3Wxmc",
      "https://www.youtube.com/watch?v=uGd7JwYe78A",
    ],
  },
  {
    name:
      "Aspectos Relevantes del Plan de Recuperaciondel Sector Electrico Venezolano - VESRP",
    img: "./images/eventplaceholdernull2.png",
    day: "17",
    month: "APR, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Miguel Lara", "Jose Aguilar"],
    links: [
      "https://youtu.be/kOBwrXX9QNQ",
      "https://youtu.be/FE94ID54dxQ",
      "https://www.youtube.com/watch?v=sPw8fapYi5I",
    ],
  },
  {
    name:
      "Un plan para recuperar el sector petróleo y gas con base a 100% esfuerzo privado",
    img: "./images/eventplaceholdernull2.png",
    day: "10",
    month: "APR, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Evanan Romero"],
    links: [
      "https://youtu.be/ZXxvnVch32Q",
      "https://youtu.be/vh-MjnRF3n8",
      "https://www.youtube.com/watch?v=yYtnbVPYat8",
    ],
  },
  {
    name:
      "Me acaban de nombrar Ministro de Energía y el Presidente me pregunta: Qué vamos a hacer en los próximos 6 meses? Esta es mi respuesta",
    img: "./images/eventplaceholdernull2.png",
    day: "03",
    month: "APR, 20",
    year: "2020",
    type: "Webinar",
    time: "FRI 10AM - 11AM (CT)",
    presenters: ["Humberto Calderon Berti", "Horacio Medina", "Eugenio Montoro"],
    links: [
      "https://youtu.be/2JfO5_Q4zAM",
      "https://youtu.be/LX7BdIkdHEc",
      "https://youtu.be/-NS7oIMBaUU",
      "https://youtu.be/XR7SxSiGX0Q",
      "https://youtu.be/h1debFvKnjA",
    ],
  },
];
